export default __webpack_public_path__ + "static/media/compare-icon.540ba69c.svg";